var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLock = function SvgLock(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x36_4px_boxes"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Production"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#565D64",
    d: "M48,27.0236v-4.5238C48,13.4019,40.5979,6,31.5,6S15,13.4019,15,22.4998v4.5238 c-3,0.2568-6,3.0596-6,6.4745V51.498C9,55.0819,11.8564,58,15.4404,58h32.001C51.0254,58,54,55.0819,54,51.498V33.4982 C54,30.0833,51,27.2805,48,27.0236z M49,51.498C49,52.3109,48.2539,53,47.4414,53h-32.001C14.6279,53,14,52.3109,14,51.498 V33.4982C14,32.6852,14.6279,32,15.4404,32H20v-9.5002c0-6.3412,5.158-11.4999,11.5-11.4999S43,16.1586,43,22.4998V27H24v5 h23.4414C48.2539,32,49,32.6852,49,33.4982V51.498z M31.5,36.9981c-4.2831,0-6.28,5.6934-2.4995,8.1863 c0.0244,0.0176,0.0464,0.0386,0.0712,0.0558V49h4.8566v-3.7598c0.025-0.0173,0.0471-0.0384,0.0718-0.0562 C37.7797,42.6902,35.7834,36.9981,31.5,36.9981z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.41aba87a20c069790dee58bc89893d24.svg";